<template>
  <v-layout row pa-3>
    <!-- v-fab-transition>
      <v-btn color="pink" dark fixed bottom right fab @click="createItem">
        <v-icon>add</v-icon>
      </v-btn>
    </v-fab-transition-->
    <v-flex xs12 sm12>
      <v-alert :value="noData" dismissible color="error" icon="warning" outlined
        >We can't find a coupon. Please use coupon id.</v-alert
      >
      <v-card>
        <v-toolbar text>
          <v-icon>receipt</v-icon>
          <v-toolbar-title>Coupons</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-flex xs6>
            <v-container pa-0>
              <v-layout align-center row>
                Number per pages :
                <v-flex xs1 pa-2>
                  <v-select
                    :items="pageStepChoices"
                    v-model="pageStep"
                  ></v-select>
                </v-flex>
                <v-text-field
                  v-model="searchQuery"
                  v-on:keyup.enter="search(searchQuery)"
                ></v-text-field>
                <v-btn icon @click.stop="search(searchQuery)">
                  <v-icon>search</v-icon>
                </v-btn>
              </v-layout>
            </v-container>
          </v-flex>
        </v-toolbar>
        <v-data-table
          :headers="headers"
          :items="items"
          class="mt-1"
          hide-default-footer
          :loading="loading"
        >
          <template v-slot:item="props">
            <tr>
              <td>{{ props.item.id }}</td>
              <td>{{ props.item.name }}</td>
              <td>
                <span v-if="props.item.amount_off"
                  >{{ props.item.amount_off }}€</span
                >
                <span v-else>{{ props.item.percent_off }} %</span>
              </td>
              <td>
                <span v-if="props.item.duration === 'repeating'"
                  >{{ props.item.duration_in_months }} months</span
                >
                <span v-else>{{ props.item.duration }}</span>
              </td>
              <td>{{ props.item.valid ? "true" : "false" }}</td>
              <td>{{ props.item.created | moment("YYYY-DD-MM") }}</td>
              <td></td>
            </tr>
          </template>
          <template v-slot:no-data>No data</template>
        </v-data-table>
        <v-footer>
          <v-btn text @click.stop="previousItems()">Previous</v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click.stop="nextItems()">Next</v-btn>
        </v-footer>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import fb from "@/firebase";
import { mapState, mapGetters, mapMutations } from "vuex";

const coupons = fb.db.collection("business_coupons").limit(10);

export default {
  components: {},
  data: () => ({
    items: [],
    newItemName: "",
    currentItem: {},
    lastVisible: "",
    searchQuery: "",
    noData: false,
    itemFound: {},
    pageStepChoices: [10, 20, 50, 100, 200],
    pageStep: 10,
    headers: [
      { text: "Coupon ID", value: "id", sortable: false },
      { text: "Name", value: "name", sortable: false },
      { text: "Discount", value: "discount", sortable: false },
      { text: "Duration", value: "duration", sortable: false },
      { text: "Is valid?", value: "valid", sortable: false },
      { text: "Created", value: "created", sortable: false },
      { text: "Actions", value: "name", sortable: false, align: "center" }
    ],
    loading: false
  }),
  computed: {
    ...mapState(["businesses", "plans"]),
    ...mapGetters(["isAdmin"])
  },
  firestore: {
    items: coupons
  },
  watch: {
    pageStep: function() {
      this.$bind(
        "items",
        fb.db.collection("business_coupons").limit(this.pageStep)
      );
    },
    items(val) {
      if (val.length > 0 && val.length <= this.pageStep) {
        this.lastVisible = val[val.length - 1].email;
      }
    }
  },
  methods: {
    ...mapMutations(["setAppAlert"]),
    createItem: function() {},
    updateItem: function(item) {
      this.currentItem = Object.assign({}, item);
      this.currentItem.id = item.id;
    },
    nextItems: function() {
      this.$bind(
        "items",
        fb.db
          .collection("business_coupons")
          .limit(this.pageStep)
          .startAt(this.lastVisible)
      );
    },
    previousItems: function() {
      this.$bind(
        "items",
        fb.db
          .collection("business_coupons")
          .limit(this.pageStep)
          .endAt(this.lastVisible)
      );
    },
    search: function(query) {
      this.noData = false;
      let ref = fb.db.collection("business_coupons");
      if (query && query.length >= 5) {
        if (/^\d+$/.test(query)) {
          ref
            .where("name", "==", query)
            .get()
            .then(snapshot => {
              if (snapshot.empty) {
                this.noData = true;
              } else {
                snapshot.forEach(doc => {
                  this.itemFound = doc.data();
                  this.itemFound.id = doc.id;
                });
                this.items = [this.itemFound];
              }
            })
            .catch(() => {
              this.noData = true;
            });
        } else {
          ref = ref
            .doc(query)
            .get()
            .then(doc => {
              if (doc.data()) {
                this.itemFound = doc.data();
                this.itemFound.id = doc.id;
                this.items = [this.itemFound];
              } else {
                this.noData = true;
              }
            })
            .catch(() => {
              this.noData = true;
            });
        }
      } else {
        this.$bind("items", coupons);
      }
    },
    businessName: function(item) {
      if (item.business) {
        let business = this.businesses.find(function(element) {
          return element.id === item.business;
        });
        if (business !== undefined) {
          return business.name;
        }
        return "";
      }
    },
    planName: function(item) {
      if (item.current_subscription) {
        let plan = this.plans.find(function(element) {
          return element.id === item.current_subscription;
        });
        if (plan !== undefined) {
          return plan.code;
        }
        return "";
      }
    }
  }
};
</script>
